import React from 'react';
import { Users, DollarSign, BarChart2, MonitorSmartphone } from 'lucide-react';
export function WeNeedSection() {
  return <section id="we-need" className="py-16 bg-white" data-id="element-142">
      <div className="container mx-auto px-4" data-id="element-143">
        <h2 className="text-3xl font-bold text-center mb-4" data-id="element-144">Join Our Team</h2>
        <p className="text-gray-700 text-center mb-6 max-w-2xl mx-auto" data-id="element-145">
          We're building the future of sports networking and looking for
          passionate individuals to join us in these key areas:
        </p>
        {/* Mobile-optimized version */}
        <div className="md:hidden" data-id="element-146">
          <div className="space-y-6 mb-8" data-id="element-147">
            <div className="bg-blue-500 text-white p-6 rounded-lg shadow-md" data-id="element-148">
              <h3 className="text-xl font-bold mb-1 text-center" data-id="element-149">
                SPORT SPECIALIST
              </h3>
              <p className="text-center text-white text-opacity-90" data-id="element-150">
                Sports industry expertise & knowledge
              </p>
            </div>
            <div className="bg-blue-500 text-white p-6 rounded-lg shadow-md" data-id="element-151">
              <h3 className="text-xl font-bold mb-1 text-center" data-id="element-152">
                MARKETING & ADVERTIZING
              </h3>
              <p className="text-center text-white text-opacity-90" data-id="element-153">
                Brand building & outreach
              </p>
            </div>
            <div className="bg-slate-600 text-white p-6 rounded-lg shadow-md" data-id="element-154">
              <h3 className="text-xl font-bold mb-1 text-center" data-id="element-155">
                FINANCE & PARTNERSHIPS
              </h3>
              <p className="text-center text-white text-opacity-90" data-id="element-156">
                Business development & funding
              </p>
            </div>
            <div className="bg-blue-300 text-white p-6 rounded-lg shadow-md" data-id="element-157">
              <h3 className="text-xl font-bold mb-1 text-center" data-id="element-158">
                IT & SOCIAL MEDIA
              </h3>
              <p className="text-center text-white text-opacity-90" data-id="element-159">
                Tech development & digital presence
              </p>
            </div>
          </div>
        </div>
        {/* Desktop version with the original SVG diagram */}
        <div className="hidden md:flex justify-center" data-id="element-160">
          <div className="relative w-full max-w-3xl" data-id="element-161">
            <div className="px-0 sm:px-4" data-id="element-162">
              <svg viewBox="0 0 600 500" className="w-full h-auto" preserveAspectRatio="xMidYMid meet" data-id="element-163">
                {/* Background elements - sports field lines */}
                <rect x="50" y="50" width="500" height="400" rx="20" fill="#f8fafc" stroke="#e2e8f0" strokeWidth="2" data-id="element-164" />
                <circle cx="300" cy="250" r="100" fill="none" stroke="#e2e8f0" strokeWidth="2" strokeDasharray="5,5" data-id="element-165" />
                <line x1="50" y1="250" x2="550" y2="250" stroke="#e2e8f0" strokeWidth="2" strokeDasharray="10,10" data-id="element-166" />
                <line x1="300" y1="50" x2="300" y2="450" stroke="#e2e8f0" strokeWidth="2" strokeDasharray="10,10" data-id="element-167" />
                {/* Center SportProZ Logo with enhanced presentation */}
                <circle cx="300" cy="250" r="90" fill="#f3f4f6" stroke="#e5e7eb" strokeWidth="4" data-id="element-168" />
                <image href="https://uploadthingy.s3.us-west-1.amazonaws.com/tZt8Y24BXXUUFMEFqS2eFe/sport-pro-04-min_2.png" x="235" y="210" height="80" width="130" data-id="element-169" />
                <text x="300" y="310" textAnchor="middle" fill="#374151" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif" data-id="element-170">
                  TEAM SPORTPROZ
                </text>
                {/* Sport Specialist */}
                <circle cx="300" cy="100" r="60" fill="#3b82f6" data-id="element-171" />
                <circle cx="300" cy="100" r="50" fill="#3b82f6" stroke="white" strokeWidth="2" data-id="element-172" />
                <text x="300" y="95" textAnchor="middle" fill="white" fontSize="13" fontWeight="bold" fontFamily="Arial, sans-serif" filter="drop-shadow(0px 1px 1px rgba(0,0,0,0.3))" data-id="element-173">
                  SPORT
                </text>
                <text x="300" y="115" textAnchor="middle" fill="white" fontSize="13" fontWeight="bold" fontFamily="Arial, sans-serif" filter="drop-shadow(0px 1px 1px rgba(0,0,0,0.3))" data-id="element-174">
                  SPECIALIST
                </text>
                {/* Finance & Partnerships */}
                <circle cx="480" cy="250" r="60" fill="#64748b" data-id="element-175" />
                <circle cx="480" cy="250" r="50" fill="#64748b" stroke="white" strokeWidth="2" data-id="element-176" />
                <text x="480" y="245" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif" filter="drop-shadow(0px 1px 1px rgba(0,0,0,0.3))" data-id="element-177">
                  FINANCE &
                </text>
                <text x="480" y="262" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif" filter="drop-shadow(0px 1px 1px rgba(0,0,0,0.3))" data-id="element-178">
                  PARTNERSHIPS
                </text>
                {/* IT Social Media AI */}
                <circle cx="300" cy="400" r="60" fill="#93c5fd" data-id="element-179" />
                <circle cx="300" cy="400" r="50" fill="#93c5fd" stroke="white" strokeWidth="2" data-id="element-180" />
                <text x="300" y="390" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif" filter="drop-shadow(0px 1px 1px rgba(0,0,0,0.3))" data-id="element-181">
                  IT &
                </text>
                <text x="300" y="407" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif" filter="drop-shadow(0px 1px 1px rgba(0,0,0,0.3))" data-id="element-182">
                  SOCIAL MEDIA
                </text>
                <text x="300" y="424" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif" filter="drop-shadow(0px 1px 1px rgba(0,0,0,0.3))" data-id="element-183">
                  AI
                </text>
                {/* Marketing & Com */}
                <circle cx="120" cy="250" r="60" fill="#3b82f6" data-id="element-184" />
                <circle cx="120" cy="250" r="50" fill="#3b82f6" stroke="white" strokeWidth="2" data-id="element-185" />
                <text x="120" y="245" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif" filter="drop-shadow(0px 1px 1px rgba(0,0,0,0.3))" data-id="element-186">
                  MARKETING
                </text>
                <text x="120" y="262" textAnchor="middle" fill="white" fontSize="12" fontWeight="bold" fontFamily="Arial, sans-serif" filter="drop-shadow(0px 1px 1px rgba(0,0,0,0.3))" data-id="element-187">
                  & COMMS
                </text>
                {/* Connection lines with animated dashes */}
                <path d="M340 135 Q 400 180 440 215" stroke="#3b82f6" strokeWidth="4" fill="none" strokeLinecap="round" strokeDasharray="8,8" data-id="element-188">
                  <animate attributeName="stroke-dashoffset" from="16" to="0" dur="2s" repeatCount="indefinite" data-id="element-189" />
                </path>
                <path d="M440 285 Q 400 320 340 365" stroke="#64748b" strokeWidth="4" fill="none" strokeLinecap="round" strokeDasharray="8,8" data-id="element-190">
                  <animate attributeName="stroke-dashoffset" from="16" to="0" dur="2s" repeatCount="indefinite" data-id="element-191" />
                </path>
                <path d="M260 365 Q 200 320 160 285" stroke="#93c5fd" strokeWidth="4" fill="none" strokeLinecap="round" strokeDasharray="8,8" data-id="element-192">
                  <animate attributeName="stroke-dashoffset" from="16" to="0" dur="2s" repeatCount="indefinite" data-id="element-193" />
                </path>
                <path d="M160 215 Q 200 180 260 135" stroke="#3b82f6" strokeWidth="4" fill="none" strokeLinecap="round" strokeDasharray="8,8" data-id="element-194">
                  <animate attributeName="stroke-dashoffset" from="16" to="0" dur="2s" repeatCount="indefinite" data-id="element-195" />
                </path>
              </svg>
            </div>
          </div>
        </div>
        <div className="mt-8 md:mt-12 text-center" data-id="element-196">
          <p className="text-gray-700 max-w-2xl mx-auto mb-8" data-id="element-197">
            Our vision requires diverse expertise to create the ultimate sports
            networking platform. If you're passionate about sports and
            technology, we'd love to hear from you!
          </p>
          <a href="#contact" className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-lg transition-colors inline-block" data-id="element-198">
            Join Our Team
          </a>
        </div>
      </div>
    </section>;
}